var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxtFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3800 4800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M0 4800h3800V840L2960 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBB",
    d: "M2960 840h840L2960 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#888",
    d: "M3800 1680V840h-840"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#555",
    d: "M900 1976h2000v-212H900m0 670h2000v-211H900m0 670h2000v-212H900m0 635h1200v-176H900"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtFileIcon);
export default __webpack_public_path__ + "static/media/txtFileIcon.9136fde5f7c1d096197b7816617276af.svg";
export { ForwardRef as ReactComponent };